import { ee } from '../eventEmitter';
import meta from '../../data/meta.json';
import data from '../../data/basic.json';

const hello = require('hellojs');

const isProd = process.env.NODE_ENV === 'production';

// ! change it
// const REDIRECT_URI_PROD = 'https://ig.rambler.ru/tiger-new-year-2022-game-stage/';
const REDIRECT_URI_PROD = `${meta.url}${meta.base}`;
// const REDIRECT_URI_DEV = 'http://localhost:8080/';

const HELLO_CONFIG = [
    {
        // facebook: data.settings.fbclientid,
        vk: data.settings.vkcliendid,
        google: data.settings.gglclientid
    },
    {
        oauth_proxy: data.settings.oauth,
        redirect_uri: isProd ? REDIRECT_URI_PROD : 'http://localhost:8080/'
    }
];

export class Auth {
    #isLogin = false;
    #user = {
        username: null,
        id: null,
        network: null
    };

    get user() {
        return this.#user;
    }

    #loginNetwork;
    #isAuthPageOpen = false;
    #authPage = document.getElementById('authPage');
    #toSaveResult = false;

    constructor() {
        this.initHello();
        this.initEvents();
    }

    initHello() {
        hello.init(...HELLO_CONFIG);

        hello.on('auth.login', (res) => {
            if (res.network === 'vk') {
                this.login(res.authResponse.user_id, res.network, res.authResponse.user_id);
            } else {
                hello(res.network)
                    .api('me')
                    .then((json) => {
                        this.login(json.name, res.network, json.id);
                    });
            }
        });
    }

    login(username, network, id) {
        this.#isLogin = true;

        this.#user.username = username;
        this.#user.network = network;
        this.#user.id = id;
        localStorage.setItem('username', username);
        localStorage.setItem('isLogin', true);
        this.toggleAuthButton();
        this.toggleResultsPage();

        if (this.#toSaveResult) {
            ee.emit('login');
            this.#toSaveResult = false;
        }

        if (this.#isAuthPageOpen) this.toggleAuthPage();
    }

    logout() {
        this.clearLoginInfo();
        this.toggleResultsPage();
    }

    clearLoginInfo() {
        this.#isLogin = false;
        this.#user.username = null;
        this.#user.network = null;
        this.#user.id = null;
        localStorage.removeItem('username');
        localStorage.removeItem('isLogin');
        this.toggleAuthButton();
    }

    initEvents() {
        const toggleAuthBack = document.getElementById('toggleAuthBack');
        const toggleAuthIcons = document.getElementsByClassName('auth-icon');

        Array.from(toggleAuthIcons).forEach((toggleAuthIcon) => {
            toggleAuthIcon.addEventListener('click', () => {
                if (!this.#isLogin) {
                    this.toggleAuthPage();
                } else {
                    hello(this.#user.network).logout().then(this.logout.bind(this));
                }
            });
        });

        toggleAuthBack.addEventListener('click', () => {
            this.toggleAuthPage();
        });

        const toAuthButtons = document.getElementsByClassName('auth-page__button');

        Array.from(toAuthButtons).forEach((button) => {
            button.addEventListener('click', () => {
                hello.login(button.getAttribute('network')).then((res) => res);
            });
        });

    }

    toggleAuthButton() {
        const toAuthButtons = document.getElementsByClassName('auth-icon');
        let text = 'Вход';

        if (this.#isLogin) {
            text = 'Выход';
        }

        Array.from(toAuthButtons).forEach((toAuthButton) => {
            const textEl = toAuthButton.getElementsByTagName('p')[0];

            toAuthButton.classList.toggle('button_small_only-icon');
            textEl.innerHTML = text;
        });
    }

    toggleAuthPage(toSaveResult = false) {
        this.#toSaveResult = toSaveResult;
        this.#isAuthPageOpen = !this.#isAuthPageOpen;
        ee.emit('toggleInsidePage');
        this.#authPage.classList.toggle('auth-page_active');
    }

    // eslint-disable-next-line
    toggleResultsPage() {
        const resultsPage = document.getElementById('resultsPage');

        resultsPage.classList.toggle('results-page_is-auth');
    }
}
